import { useState } from 'react';
import styled from 'styled-components';
import { Button } from '../../../../components/common/buttons/Button';
import { ProductInquiryModal } from '../../../../components/custom/modal/product/ProductInquiryModal';
import { IProductForInquiry, useHandleProductInquiry } from '../../../../hooks/product/useHandleProductInquiry';
import { useCheckUserLoggedIn } from '../../../../hooks/user/useCheckUserLoggedIn';
import { IProduct } from '../../../../interfaces/Product.interfaces';

interface RequestConsultButtonProps {
  product: IProduct;
  category: 'PLUVA' | 'PARTNER';
}

export const RequestConsultButton = ({ product, category }: RequestConsultButtonProps) => {
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  const [isProductInquiryModalOpen, setIsProductInquiryModalOpen] = useState<boolean>(false);

  const { handleProductInquiryButtonClick } = useHandleProductInquiry({
    product: product as IProductForInquiry,
    pageType: 'pdp',
  });

  return (
    <>
      <ButtonWrapper>
        <Button
          borderType={'square'}
          size={'lg'}
          color={'filledPrimaryStrong'}
          text={{ size: 'lg', content: '가격 상담 031-607-4997' }}
          onClick={() => {
            handleProductInquiryButtonClick();
            if (!isUserLoggedIn) {
              setIsProductInquiryModalOpen(true);
            }
          }}
        />
        <Tooltip>
          <TooltipText>{'에누리 가능해요 ✨'}</TooltipText>
        </Tooltip>
      </ButtonWrapper>

      {isProductInquiryModalOpen && (
        <ProductInquiryModal
          product={product}
          pageType={'pdp'}
          onModalClose={() => setIsProductInquiryModalOpen(false)}
        />
      )}
    </>
  );
};

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;

  position: relative;
`;

const Tooltip = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 8px 16px;

  gap: 8px;

  position: absolute;

  top: -44px;
  left: 50%;
  transform: translateX(-50%);

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-offblack, #505363);

  overflow: visible;

  &:after {
    border-top: 6px solid #505363;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 0px solid transparent;
    content: '';
    position: absolute;
    bottom: -6px;
    left: 50%;

    transform: translate(-50%, 0%);
  }
`;

const TooltipText = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* Display/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
`;
